export enum GridType{
  rectangle = 'rectangle',
  hexagon = 'hexagon'
}

export interface Grid {
  getCellIndex: (xy: number[]) => number[],
  getCellCenter: (index: number[]) => number[]
}

export class RectangleGrid implements Grid {

  private cellWidth: number;
  private cellHeight: number;

  public constructor(cellWidth: number, cellHeight?: number) {
    this.cellWidth = cellWidth;
    this.cellHeight = cellHeight === undefined ? cellWidth : cellHeight;
  }

  public getCellIndex(xy: number[]): number[] {
    return [
      Math.floor(xy[0] / this.cellWidth + 0.5),
      Math.floor(xy[1] / this.cellHeight + 0.5)
    ];
  }

  public getCellCenter(cellIndex: number[]): number[] {
    return [
      cellIndex[0] * this.cellWidth,
      cellIndex[1] * this.cellHeight,
    ];
  }

}

export class HexagonGrid implements Grid {

  public static A = Math.sqrt(3.0) * 0.25;
  private majorSize: number;
  private majorSize075: number;
  private minorSize: number;
  private majorCoordinate: number;
  private minorCoordinate: number;

  public constructor(ribSize: number, horizontal: boolean) {
    this.majorSize = ribSize * 2.0;
    this.majorSize075 = this.majorSize * 0.75;
    this.minorSize = this.majorSize * 2.0 * HexagonGrid.A;
    this.majorCoordinate = horizontal ? 0 : 1;
    this.minorCoordinate = 1 - this.majorCoordinate;
  }

  public getCellIndex(xy: number[]): number[] {
    let majorIndex = Math.floor(xy[this.majorCoordinate] / this.majorSize075 + 0.5);
    let oddIndex = (majorIndex % 2);
    let majorCenter = majorIndex * this.majorSize075;
    let deltaMajor = xy[this.majorCoordinate] - majorCenter;

    let minorIndex = Math.floor(xy[this.minorCoordinate] / this.minorSize + 0.5 * (1 - oddIndex));
    let minorCenter = (minorIndex + 0.5 * oddIndex) * this.minorSize;
    let deltaMinor = xy[this.minorCoordinate] - minorCenter;

    let outside = Math.ceil(HexagonGrid.A * ((Math.abs(deltaMajor) / this.majorSize) - 0.5) + 0.25 * (Math.abs(deltaMinor) / this.majorSize));

    majorIndex += (Math.sign(deltaMajor) * outside);
    minorIndex += (Math.sign(deltaMinor) * outside);

    let index = new Array(2);
    index[this.majorCoordinate] = majorIndex;
    index[this.minorCoordinate] = minorIndex;
    return index;
  }

  public getCellCenter(cellIndex: number[]): number[] {
    let center = new Array(2);
    center[this.majorCoordinate] = cellIndex[this.majorCoordinate] * this.majorSize075;
    center[this.minorCoordinate] = (cellIndex[this.minorCoordinate] + 0.5 * (cellIndex[this.majorCoordinate] % 2)) * this.minorSize;
    return center;
  }

}
